"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfessionalLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../../Icons");

var _Link = _interopRequireDefault(require("./Link"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Row = _styledComponents.default.div.withConfig({
  displayName: "Row",
  componentId: "ktqdlm-0"
})(["display:flex;align-items:center;margin-bottom:", ";a{margin:0;}svg{fill:", ";color:", ";width:1rem;margin-right:0.5rem;}"], function (p) {
  return (0, _helpers.getSpacing)(p.spacing);
}, (0, _helpers.color)('brand'), (0, _helpers.color)('brand'));

var SOCIAL_LABELS = {
  Glassdoor: /glassdoor\.com/i,
  Github: /github\.(com|io)/i,
  Dribbble: /dribbble\.com/i,
  LinkedIn: /linkedin\.com/i,
  Google: /google\.com/i
};
var SOCIAL_ICONS = {
  google: _Icons.GoogleIcon,
  github: _Icons.GithubIcon,
  dribbble: _Icons.DribbbleIcon,
  linkedin: _Icons.LinkedinIcon,
  glassdoor: _Icons.GlassdoorIcon
};

var getSocialLabel = function getSocialLabel(link) {
  var match = Object.entries(SOCIAL_LABELS).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        siteRegex = _ref2[1];

    return siteRegex.test(link);
  });
  return match && match[0];
};

var SocialIcon = function SocialIcon(_ref3) {
  var type = _ref3.type;
  var Icon = SOCIAL_ICONS[type] || _Icons.LinkIcon;
  return _react.default.createElement(Icon, null);
};

var ProfessionalLink = function ProfessionalLink(_ref4) {
  var url = _ref4.url,
      label = _ref4.label,
      className = _ref4.className,
      _ref4$spacing = _ref4.spacing,
      spacing = _ref4$spacing === void 0 ? 'medium' : _ref4$spacing,
      props = _objectWithoutProperties(_ref4, ["url", "label", "className", "spacing"]);

  var socialLabel = getSocialLabel(url);
  return _react.default.createElement(Row, {
    key: url,
    spacing: spacing,
    className: className
  }, _react.default.createElement(SocialIcon, {
    type: socialLabel ? socialLabel.toLowerCase() : 'link'
  }), _react.default.createElement(_Link.default, _extends({}, props, {
    to: url,
    target: "_blank"
  }), label));
};

exports.ProfessionalLink = ProfessionalLink;